var render = function () {
  var _vm$item, _vm$item$profile;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "grey lighten-5"
    }
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : (_vm$item$profile = _vm$item.profile) === null || _vm$item$profile === void 0 ? void 0 : _vm$item$profile.src
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-icon', [_vm._v("mdi-account")])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-col', {
    staticClass: "pa-4"
  }, [_c('v-list-item-title', {
    staticClass: "d-flex flex-row align-center"
  }, [_vm._v(" " + _vm._s(_vm.item.name) + " "), _vm.isItemInterviewer ? [_c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "color": "#fab617",
      "small": ""
    }
  }, [_vm._v("mdi-crown")])] : _vm._e()], 2), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.item.username) + " ")])], 1), _c('v-col', {
    staticClass: "py-4 px-12",
    attrs: {
      "cols": "auto",
      "align-self": "start"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-icon', _vm._g(_vm._b({
          attrs: {
            "size": "x-small"
          }
        }, 'v-icon', Object.assign({}, attrs, {
          color: _vm.color
        }), false), on), [_vm._v(" mdi-circle ")])];
      }
    }])
  }, [_vm._v(" " + _vm._s(_vm.tooltip) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }